export const data=[
  {
    "Program_Category": "Arts",
    "Program_Code": "EXP2021-JR",
    "Program_Name": "Exploratorium Junior",
    "Program_Chair": "Carly Purmort",
    "Program_Chair_Email": "lpimentel@oakwoodschool.org",
    "Grades": "1-3",
    "Program_Description": "Does your child want to spend a fun-filled two weeks exploring various elements of the arts?! The Junior Exploratorium offers students of all levels a fun and encouraging environment, allowing each child the opportunity to discover and celebrate his or her own inherent skills, talents, and artistic expression! Based on a personal interview/screening, we strive to organize a schedule grounded on everyone's interests! Sample enrichment opportunities include exploration in the visual arts, improv, dance, hand-drumming and more!",
    "Prerequisites": "None",
    "Location": "Oakwood Elementary School",
    "Length_In_Weeks": 2,
    "Start_Date": "July 6",
    "End_Date": "July 18",
    "Start_Time": "9:00 AM",
    "End_Time": "1:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "24 max",
    "Tuition": "$1,000.00",
    "Material_Fee": "",
    "Hrs_per_day": "4:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/208172",
    "Grade_00": "FALSE",
    "Grade_01": "TRUE",
    "Grade_02": "TRUE",
    "Grade_03": "TRUE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Carly Purmort",
    "Instructor_email": "cpurmort@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Arts",
    "Program_Code": "SSE2021-39",
    "Program_Name": "100 Years of SciFi Cinema",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "7-10",
    "Program_Description": "In this class, we will go back in time and examine how Science Fiction Films have changed with the times and as technology advanced. We'll watch German expressionism films from the 20's, drive-in films from the 50's, blockbusters from the 90's and so much more.",
    "Prerequisites": "None",
    "Location": "Virtual",
    "Length_In_Weeks": 1,
    "Start_Date": "August 2",
    "End_Date": "August 6",
    "Start_Time": "1:00 PM",
    "End_Time": "1:45 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$125.00",
    "Material_Fee": "",
    "Hrs_per_day": "0:45:00",
    "In_Person": "FALSE",
    "Virtual": "TRUE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/214035",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "TRUE",
    "Grade_10": "TRUE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Kwesi Johnson",
    "Instructor_email": "wjohnson@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Humanities",
    "Program_Code": "SSE2021-18",
    "Program_Name": "Creative Writing",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "8-11",
    "Program_Description": "This course will explore various modes of writing such as poetry, short stories, and screenplays. We will incorporate exercises that will allow us to work on our writing skills together, and we will take time to read, edit, and appreciate each other's work. Whether you are a seasoned writer or are just developing an interest in creative writing, we would love to have you!",
    "Prerequisites": "None",
    "Location": "Oakwood Secondary School",
    "Length_In_Weeks": 1,
    "Start_Date": "June 28",
    "End_Date": "July 2",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/213765",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "TRUE",
    "Grade_10": "TRUE",
    "Grade_11": "TRUE",
    "Grade_12": "TRUE",
    "Grade_12+": "TRUE",
    "instructor": "Paulina Phelps",
    "Instructor_email": "pphelps@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Science",
    "Program_Code": "SSE2021-37",
    "Program_Name": "Ecology and the LA River",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "7-12+",
    "Program_Description": "It may be more famous as a movie set and a car racing location, but the LA River is actually a thriving natural environment! After learning about some principles of ecology, we’ll venture out to the LA river to collect samples and make scientific observations. Back in the lab, we’ll analyze our samples and check out the amazing diversity of life hiding in this urban river. Health situation permitting, we’ll kayak along the river to collect our samples!\nNote: This course will meet in an off-campus location along the LA river one day, and require an additional fee for kayaking if available.",
    "Prerequisites": "None",
    "Location": "Oakwood Secondary School",
    "Length_In_Weeks": 1,
    "Start_Date": "July 26",
    "End_Date": "July 30",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/214103",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "TRUE",
    "Grade_10": "TRUE",
    "Grade_11": "TRUE",
    "Grade_12": "TRUE",
    "Grade_12+": "TRUE",
    "instructor": "Andrew Miller",
    "Instructor_email": "amiller@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Arts",
    "Program_Code": "SSE2021-40",
    "Program_Name": "Fast Future Filmmakers",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "7-9",
    "Program_Description": "Whether you've never used iMovie or you're a Junior Ryan Coogler, this class is for you! In one week we’ll write scripts, act, shoot, and edit your film all while learning about some of the greatest films of all time.",
    "Prerequisites": "None",
    "Location": "Oakwood Secondary School",
    "Length_In_Weeks": 1,
    "Start_Date": "August 2",
    "End_Date": "August 6",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/214114",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "TRUE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Kwesi Johnson",
    "Instructor_email": "wjohnson@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Arts",
    "Program_Code": "SSE2021-40",
    "Program_Name": "Fast Future Filmmakers",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "7-9",
    "Program_Description": "Whether you've never used iMovie or you're a Junior Ryan Coogler, this class is for you! In one week we’ll write scripts, act, shoot, and edit your film all while learning about some of the greatest films of all time.",
    "Prerequisites": "None",
    "Location": "Oakwood Secondary School",
    "Length_In_Weeks": 1,
    "Start_Date": "July 26",
    "End_Date": "July 30",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/239907",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "TRUE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Kwesi Johnson",
    "Instructor_email": "wjohnson@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Just-for-Fun",
    "Program_Code": "",
    "Program_Name": "Geocaching",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "7-12",
    "Program_Description": "There’s gold in them thar hills!  Well, maybe not gold, but there are buried treasures all around us.  We’ll use the GPS in our smartphones to go geocaching along different trails throughout Griffith Park.  If you enjoy hiking and adventure, this is the course for you!\nNote: This course meets in Griffith Park.",
    "Prerequisites": "None",
    "Location": "Off-Campus",
    "Length_In_Weeks": 1,
    "Start_Date": "July 26",
    "End_Date": "July 30",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/215777",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "TRUE",
    "Grade_10": "TRUE",
    "Grade_11": "TRUE",
    "Grade_12": "TRUE",
    "Grade_12+": "FALSE",
    "instructor": "Nicole Luque",
    "Instructor_email": "nluque@oakwoodschool.org",
    "New_since_Mar10": "NEW!",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Humanities",
    "Program_Code": "SSE2021-23",
    "Program_Name": "GLAM: The History of Fashion",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "8-12+",
    "Program_Description": "How did we go from huge gowns & frock suits to today's fashion styling? When did corsets go out of style and why? And how did Gaga change fashion as we know it? Well, let me tell you! As a fashion lover and costume designer, I've had to learn fashion history from the first pair of shoes made by Neanderthals to the iconic fashions seen today. We'll touch on it all.",
    "Prerequisites": "None",
    "Location": "Virtual",
    "Length_In_Weeks": 1,
    "Start_Date": "August 2",
    "End_Date": "August 6",
    "Start_Time": "2:00 PM",
    "End_Time": "2:45 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$125.00",
    "Material_Fee": "",
    "Hrs_per_day": "0:45:00",
    "In_Person": "FALSE",
    "Virtual": "TRUE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/213767",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "FALSE",
    "Grade_08": "TRUE",
    "Grade_09": "TRUE",
    "Grade_10": "TRUE",
    "Grade_11": "TRUE",
    "Grade_12": "TRUE",
    "Grade_12+": "TRUE",
    "instructor": "Johnnyangel Pineda",
    "Instructor_email": "jpineda@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Mathematics & Coding/STEAM",
    "Program_Code": "SSE2021-06",
    "Program_Name": "Introduction to Coding & Robotics",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "7-10",
    "Program_Description": "Do you want to build a robot? Like making decisions or solving problems?  This course is designed for rising and current middle school students who are interested in coding, Robotics, like to build things, or just want to challenge themselves with something new. Anyone can learn to code, and there will be opportunities for kids of all experience levels to have a great time! By the end of this week, you’ll have your own robot to take home and the skills to program it.",
    "Prerequisites": "None",
    "Location": "Oakwood Secondary School",
    "Length_In_Weeks": 1,
    "Start_Date": "July 19",
    "End_Date": "July 23",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "$70.00",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/214187",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "TRUE",
    "Grade_10": "TRUE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Damon Falconer",
    "Instructor_email": "daflconer@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Mathematics & Coding/STEAM",
    "Program_Code": "SSE2021-28",
    "Program_Name": "Math Camp: High School",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "9-11",
    "Program_Description": "This course is designed to strengthen high school students' math skills and enhance their ability to succeed in future classes. Topics from algebra and geometry as well as trigonometry and pre-calculus will be included, and students will improve their facility with scientific calculators and the Desmos computer graphing program. Games and breakout sessions will allow students to work collaboratively to interpret and solve applied problems. Students will experience the joy of problem solving and gain confidence in their inductive and deductive reasoning skills.",
    "Prerequisites": "None",
    "Location": "Virtual",
    "Length_In_Weeks": 1,
    "Start_Date": "July 12",
    "End_Date": "July 16",
    "Start_Time": "11:00 AM",
    "End_Time": "11:45 AM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$125.00",
    "Material_Fee": "",
    "Hrs_per_day": "0:45:00",
    "In_Person": "FALSE",
    "Virtual": "TRUE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/213777",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "TRUE",
    "Grade_10": "TRUE",
    "Grade_11": "TRUE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Peter Wingerd",
    "Instructor_email": "pwingerd@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Mathematics & Coding/STEAM",
    "Program_Code": "SSE2021-27",
    "Program_Name": "Math Camp: Middle School",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "7-8",
    "Program_Description": "This course is designed to strengthen middle school students' math skills and enhance their ability to succeed in future classes. Topics from algebra and geometry will be included, and students will improve their facility with scientific calculators and the Desmos computer graphing program. Games and breakout sessions will allow students to work collaboratively to interpret and solve applied problems. Students will experience the joy of problem solving and gain confidence in their inductive and deductive reasoning skills.",
    "Prerequisites": "None",
    "Location": "Virtual",
    "Length_In_Weeks": 1,
    "Start_Date": "July 12",
    "End_Date": "July 16",
    "Start_Time": "10:00 AM",
    "End_Time": "10:45 AM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$125.00",
    "Material_Fee": "",
    "Hrs_per_day": "0:45:00",
    "In_Person": "FALSE",
    "Virtual": "TRUE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/213779",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Peter Wingerd",
    "Instructor_email": "pwingerd@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Humanities",
    "Program_Code": "SSE2021-05",
    "Program_Name": "Philosophy and Social Issues",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "10-12+",
    "Program_Description": "We will look at philosophical arguments concerning some of the most pressing and controversial issues facing modern societies. Click \"Register Now\" for more details on possible topics.",
    "Prerequisites": "None",
    "Location": "Oakwood Secondary School",
    "Length_In_Weeks": 1,
    "Start_Date": "June 28",
    "End_Date": "July 2",
    "Start_Time": "10:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$250.00",
    "Material_Fee": "",
    "Hrs_per_day": "2:00:00",
    "In_Person": "FALSE",
    "Virtual": "TRUE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/212490",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "TRUE",
    "Grade_11": "TRUE",
    "Grade_12": "TRUE",
    "Grade_12+": "TRUE",
    "instructor": "Mickey Morgan",
    "Instructor_email": "mmorgan@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Humanities",
    "Program_Code": "SSE2021-03",
    "Program_Name": "Political Ads",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "7-10",
    "Program_Description": "Politics is storytelling, and one of the best ways for political candidates to tell their story is through television and digital advertising. In this course, we'll look at both classic and contemporary political ads to determine who the intended audiences are, what messages were clear and powerful, and which ones had an impact on elections.",
    "Prerequisites": "None",
    "Location": "Oakwood Secondary School",
    "Length_In_Weeks": 1,
    "Start_Date": "July 26",
    "End_Date": "July 30",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/212487",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "TRUE",
    "Grade_10": "TRUE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Enzo De Palma",
    "Instructor_email": "edepalma@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Humanities",
    "Program_Code": "SSE2021-04",
    "Program_Name": "Some Great Films",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "10-12+",
    "Program_Description": "Students will watch a GREAT film each evening, and we will talk about it in class the next day.  Helpful notes and guidelines will be provided for discussions, and links to readings (entirely optional) if students want to go more deeply.  Films will be classics in the history of film, and some will have subtitles.",
    "Prerequisites": "None",
    "Location": "Virtual",
    "Length_In_Weeks": 1,
    "Start_Date": "June 28",
    "End_Date": "July 2",
    "Start_Time": "2:00 PM",
    "End_Time": "2:45 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$125.00",
    "Material_Fee": "",
    "Hrs_per_day": "0:45:00",
    "In_Person": "FALSE",
    "Virtual": "TRUE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/212489",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "TRUE",
    "Grade_11": "TRUE",
    "Grade_12": "TRUE",
    "Grade_12+": "TRUE",
    "instructor": "Mickey Morgan",
    "Instructor_email": "mmorgan@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Arts",
    "Program_Code": "SSE2021-30",
    "Program_Name": "Songwriting Workshop",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "7-12+",
    "Program_Description": "Join Oakwood’s dynamic music duo, multi-talented musician/mathematician Peter Wingerd and alum/rising songstress Emily Beihold, for a week-long workshop on songwriting and production.  Students will begin by sharing the work of artists who inspire them, and Peter and Emily will recount their own experiences writing pop songs and soundtracks.  Students will then write their own songs and/or film scores, either individually or in partnerships.  We will collaborate to create instrumental and vocal arrangements, then record and mix the songs so that the young songwriters can share and promote their original music.  Students are encouraged to work on ideas before the class begins.  No instrumental music experience required.",
    "Prerequisites": "None",
    "Location": "Oakwood Secondary School",
    "Length_In_Weeks": 1,
    "Start_Date": "July 19",
    "End_Date": "July 23",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/213893",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "TRUE",
    "Grade_10": "TRUE",
    "Grade_11": "TRUE",
    "Grade_12": "TRUE",
    "Grade_12+": "TRUE",
    "instructor": "Peter Wingerd",
    "Instructor_email": "pwingerd@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Humanities",
    "Program_Code": "SSE2021-02",
    "Program_Name": "Superheroes in Film and Television",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "7-10",
    "Program_Description": "In many ways, superheroes are our modern day gods. To truly understand them and what they say about our society, we must study the religious texts - movies and television shows! From the black and white serials of World War II to the dominance of the Marvel Cinematic Universe, superhero media has enthralled the public uniquely and singularly. In this class, we'll dive into the history of superheroes, the way Hollywood depicts them, how that depiction has changed, and what those changes say about us as a society.",
    "Prerequisites": "None",
    "Location": "Oakwood Secondary School",
    "Length_In_Weeks": 1,
    "Start_Date": "July 19",
    "End_Date": "July 23",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/208237",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "TRUE",
    "Grade_10": "TRUE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Enzo De Palma",
    "Instructor_email": "edepalma@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Science",
    "Program_Code": "SSE2021-07",
    "Program_Name": "Wild LA (grades 7-10)",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "7-10",
    "Program_Description": "With over 4,210 acres of both natural chaparral-covered terrain and landscaped parkland, Griffith Park is one of the largest municipal parks with urban wilderness areas in the United States. Put on your hiking boots and naturalist hat as we explore some of the most fascinating corners of this unique environment, right in our own backyard!\nNote: This course meets in Griffith Park.",
    "Prerequisites": "None",
    "Location": "Off-Campus",
    "Length_In_Weeks": 1,
    "Start_Date": "June 28",
    "End_Date": "July 2",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/213863",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "TRUE",
    "Grade_10": "TRUE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Morgan Stevens",
    "Instructor_email": "mstevens@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Science",
    "Program_Code": "SSE2021-12",
    "Program_Name": "Wilderness Survival & Orienteering",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "7-12+",
    "Program_Description": "Could you survive if you were dropped in the middle of the woods? In this course you’ll learn the basics of navigating with maps, compasses, the Sun and GPS, as well as how to prepare for a wilderness hike. We’ll also explore how to survive in the wilderness if you end up lost or injured. Be prepared for some outdoor adventures!\nNote: This course meets in Griffith Park.",
    "Prerequisites": "None",
    "Location": "Off-Campus",
    "Length_In_Weeks": 1,
    "Start_Date": "July 6",
    "End_Date": "July 9",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Tuesday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$280.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/213882",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "TRUE",
    "Grade_10": "TRUE",
    "Grade_11": "TRUE",
    "Grade_12": "TRUE",
    "Grade_12+": "TRUE",
    "instructor": "Andrew Miller",
    "Instructor_email": "amiller@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Humanities",
    "Program_Code": "SSE2021-27",
    "Program_Name": "Writing Bootcamp",
    "Program_Chair": "Denise Woodward",
    "Program_Chair_Email": "dwoodward@oakwoodschool.org",
    "Grades": "7-9",
    "Program_Description": "Whether you love writing or hate it, you’ll be writing more than ever before in middle and high school.\nDuring this intensive week-long writing bootcamp, we will be learning the do’s and don’ts of writing as well as proper grammar and formatting. You’ll work on developing your own unique writer’s voice so you can become the writer you always wanted to be!  We will focus on a variety of forms of writing, including expository, narrative, and argumentative.",
    "Prerequisites": "None",
    "Location": "Oakwood Secondary School",
    "Length_In_Weeks": 1,
    "Start_Date": "July 12",
    "End_Date": "July 16",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/213886",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "TRUE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Paulina Phelps",
    "Instructor_email": "pphelps@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "World Languages & Culture",
    "Program_Code": "ESE2021-L3",
    "Program_Name": "Canta y Baila Conmigo: Sing and Dance in Spanish (grades 1-2)",
    "Program_Chair": "Joanie Pimentel",
    "Program_Chair_Email": "jpimentel@oakwoodschool.org",
    "Grades": "1-2",
    "Program_Description": "Welcome elementary students to this one-week workshop of fun and learning.  Join us in this journey into the Spanish language and its cultures through music.  Sing, dance, learn, and play along to the sounds and rhythms of Spanish-speaking countries!",
    "Prerequisites": "None",
    "Location": "Oakwood Elementary School",
    "Length_In_Weeks": 1,
    "Start_Date": "July 19",
    "End_Date": "July 23",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/213755",
    "Grade_00": "FALSE",
    "Grade_01": "TRUE",
    "Grade_02": "TRUE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Marcela Budnik",
    "Instructor_email": "mbudnik@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Athletics/Sports",
    "Program_Code": "SPO2021-E2",
    "Program_Name": "Extreme Fun: Intro to Sports",
    "Program_Chair": "Joanie Pimentel",
    "Program_Chair_Email": "jpimentel@oakwoodschool.org",
    "Grades": "3-6",
    "Program_Description": "Come join our Elementary Oakwood athletic coaches in a fun-filled week of athletic activities! Students will be introduced to two different sports each day while they work to develop fundamental skills. This is the perfect opportunity for student wishing to get away from their screens and enjoy safe, physical activities with their peers.",
    "Prerequisites": "None",
    "Location": "Oakwood Elementary School",
    "Length_In_Weeks": 1,
    "Start_Date": "July 19",
    "End_Date": "July 23",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/212445",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "TRUE",
    "Grade_04": "TRUE",
    "Grade_05": "TRUE",
    "Grade_06": "TRUE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Brian Glucksman",
    "Instructor_email": "bglucksman@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Athletics/Sports",
    "Program_Code": "SPO2021-E4",
    "Program_Name": "Game On! Session 1",
    "Program_Chair": "Joanie Pimentel",
    "Program_Chair_Email": "jpimentel@oakwoodschool.org",
    "Grades": "1-2",
    "Program_Description": "Come join Oakwood's own Luke Laolagi for a week of super fun games and activities! This is the perfect opportunity for students wishing to get away from their screens and enjoy safe, physical activities with their peers. Young learners will enjoy a variety of inside and outside fun that puts an emphasis on social-emotional learning, gross-motor skill building, fair play, cooperation, and team building.",
    "Prerequisites": "None",
    "Location": "Oakwood Elementary School",
    "Length_In_Weeks": 1,
    "Start_Date": "June 28",
    "End_Date": "July 2",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "24 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/221720",
    "Grade_00": "FALSE",
    "Grade_01": "TRUE",
    "Grade_02": "TRUE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Luke Laolagi",
    "Instructor_email": "llaolagi@oakwoodschool.org",
    "New_since_Mar10": "NEW!",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Athletics/Sports",
    "Program_Code": "SPO2021-E4-2",
    "Program_Name": "Game On! Session 2",
    "Program_Chair": "Joanie Pimentel",
    "Program_Chair_Email": "jpimentel@oakwoodschool.org",
    "Grades": "1-2",
    "Program_Description": "Come join Oakwood's own Luke Laolagi for a week of super fun games and activities! This is the perfect opportunity for students wishing to get away from their screens and enjoy safe, physical activities with their peers. Young learners will enjoy a variety of inside and outside fun that puts an emphasis on social-emotional learning, gross-motor skill building, fair play, cooperation, and team building.",
    "Prerequisites": "None",
    "Location": "Oakwood Elementary School",
    "Length_In_Weeks": 1,
    "Start_Date": "July 26",
    "End_Date": "July 30",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "24 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/224175",
    "Grade_00": "FALSE",
    "Grade_01": "TRUE",
    "Grade_02": "TRUE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Luke Laolagi",
    "Instructor_email": "llaolagi@oakwoodschool.org",
    "New_since_Mar10": "NEW!",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Just-for-Fun",
    "Program_Code": "ESF2021-P3",
    "Program_Name": "Hogwarts School of Witchcraft and Wizardry",
    "Program_Chair": "Joanie Pimentel",
    "Program_Chair_Email": "jpimentel@oakwoodschool.org",
    "Grades": "2-5",
    "Program_Description": "Grab your wand and hop on the train to Hogwarts! This class will give kids the chance to be sorted into their houses, practice their spells, and learn magic just as Harry, Ron, and Hermione did. Through partaking in Harry Potter trivia, being a student in an actual 'Defense Against the Dark Arts' class, and creating their own Marauder’s Maps, students will get to experience the magic of Hogwarts first hand!\nNote: Students will be grouped into cohorts based on age.",
    "Prerequisites": "None",
    "Location": "Oakwood Elementary School",
    "Length_In_Weeks": 1,
    "Start_Date": "August 16",
    "End_Date": "August 20",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/208663",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "TRUE",
    "Grade_03": "TRUE",
    "Grade_04": "TRUE",
    "Grade_05": "TRUE",
    "Grade_06": "TRUE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Matthew Fichandler",
    "Instructor_email": "mfichandler@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Arts",
    "Program_Code": "",
    "Program_Name": "Introduction to Hip Hop",
    "Program_Chair": "Joanie Pimentel",
    "Program_Chair_Email": "jpimentel@oakwoodschool.org",
    "Grades": "4-6",
    "Program_Description": "Join professional dancer and choreographer, Ebonee Arielle, as you dive into the world of Hip Hop music and culture.  Students will learn Hip Hop dance techniques, terminology, choreography and social dance trends from 1980’s to Tik Tok trends today.  Through Hip Hop dance, students will improve their coordination, rhythm, stamina and musicality, and increase their self-confidence all while having fun and grooving to some of their favorite songs!  Our goal is to immerse students in both culture and creativity while promoting fitness and athleticism.  No experience required!",
    "Prerequisites": "None",
    "Location": "Oakwood Elementary School",
    "Length_In_Weeks": 1,
    "Start_Date": "August 9",
    "End_Date": "August 13",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/210116",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "TRUE",
    "Grade_05": "TRUE",
    "Grade_06": "TRUE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Ebonee Arielle",
    "Instructor_email": "eboneearielle@gmail.com",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Athletics/Sports",
    "Program_Code": "SPO2021-E1",
    "Program_Name": "Let's Get Moving!",
    "Program_Chair": "Joanie Pimentel",
    "Program_Chair_Email": "jpimentel@oakwoodschool.org",
    "Grades": "1-2",
    "Program_Description": "Oakwood's amazing Elementary coaches are excited to work with our youngest athletes this summer! Students will be introduced to a variety of athletic activities and sports throughout the week with an emphasis on skill building, good sportsmanship, fair-play, and cooperation. This is the perfect opportunity for students wishing to get away from their screens and enjoy safe, physical activities with their peers. Please note that this camp will be held inside and outside, weather permitting.",
    "Prerequisites": "None",
    "Location": "Oakwood Elementary School",
    "Length_In_Weeks": 1,
    "Start_Date": "June 21",
    "End_Date": "June 25",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/212444",
    "Grade_00": "FALSE",
    "Grade_01": "TRUE",
    "Grade_02": "TRUE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Melanie Thomas",
    "Instructor_email": "mthomas@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Arts",
    "Program_Code": "ESF2021-P5",
    "Program_Name": "Sew Cute: Sewing Skills",
    "Program_Chair": "Joanie Pimentel",
    "Program_Chair_Email": "jpimentel@oakwoodschool.org",
    "Grades": "4-6",
    "Program_Description": "Fashion, costumes, and cosplay all have one thread that ties them all together: sewing! Sewing allows you to express your creativity like nothing else. So, weather you want to learn how to make clothes for fashion, really like costumes for theatre, want to start cosplaying, or just want to learn/strengthen your sewing skills - this course is perfect for you! So, weather this is your first time trying to sew or you've got a handle on the basics and are ready to learn more, check out this class!",
    "Prerequisites": "None",
    "Location": "Oakwood Elementary School",
    "Length_In_Weeks": 1,
    "Start_Date": "June 21",
    "End_Date": "June 25",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$350.00",
    "Material_Fee": "$10.00",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/210108",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "TRUE",
    "Grade_05": "TRUE",
    "Grade_06": "TRUE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Johnnyangel Pineda",
    "Instructor_email": "jpineda@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Science",
    "Program_Code": "ESF2021-P4",
    "Program_Name": "Soil and Seeds",
    "Program_Chair": "Joanie Pimentel",
    "Program_Chair_Email": "jpimentel@oakwoodschool.org",
    "Grades": "1-6",
    "Program_Description": "Gardening programs offer many opportunities for youth to practice showing kindness to each other, to their community, and to our planet. Multiple lessons will be implemented to inspire students to brainstorm and complete one or more acts of kindness through the mini garden we create. Weather permitting, activities will be held in and outside.\nNote: Students will be grouped into cohorts based on age.",
    "Prerequisites": "None",
    "Location": "Oakwood Elementary School",
    "Length_In_Weeks": 1,
    "Start_Date": "August 2",
    "End_Date": "August 6",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "24 max",
    "Tuition": "$350.00",
    "Material_Fee": "$8.00",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/208657",
    "Grade_00": "FALSE",
    "Grade_01": "TRUE",
    "Grade_02": "TRUE",
    "Grade_03": "TRUE",
    "Grade_04": "TRUE",
    "Grade_05": "TRUE",
    "Grade_06": "TRUE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Lily Perry",
    "Instructor_email": "lperry@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Science",
    "Program_Code": "ESE2021-E1",
    "Program_Name": "Summer Scientists",
    "Program_Chair": "Joanie Pimentel",
    "Program_Chair_Email": "jpimentel@oakwoodschool.org",
    "Grades": "1-4",
    "Program_Description": "A fun-filled hands-on science experiment class taught by Oakwood's very own science associate, Sam. Some of the labs you’ll experiment with include making slime, growing crystals, building your own lava lamp, and mini hovercrafts. You will also be constructing a volcano throughout the week, which we will ‘erupt’ on the final class. Each class will focus on different activities; some experiments you will take home, as well as instructions on how to recreate it with your grown-ups outside of school.\nNote: Students will be grouped into cohorts based on age. *This program is also being offered the week of August 9",
    "Prerequisites": "None",
    "Location": "Oakwood Elementary School",
    "Length_In_Weeks": 1,
    "Start_Date": "June 28",
    "End_Date": "July 2",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "24 max",
    "Tuition": "$350.00",
    "Material_Fee": "$10.00",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/216309",
    "Grade_00": "FALSE",
    "Grade_01": "TRUE",
    "Grade_02": "TRUE",
    "Grade_03": "TRUE",
    "Grade_04": "TRUE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Samantha Brawn",
    "Instructor_email": "sbrawn@oakwoodschool.org",
    "New_since_Mar10": "NEW!",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Science",
    "Program_Code": "ESE2021-E1",
    "Program_Name": "Summer Scientists",
    "Program_Chair": "Joanie Pimentel",
    "Program_Chair_Email": "jpimentel@oakwoodschool.org",
    "Grades": "1-4",
    "Program_Description": "A fun-filled hands-on science experiment class taught by Oakwood's very own science associate, Sam. Some of the labs you’ll experiment with include making slime, growing crystals, building your own lava lamp, and mini hovercrafts. You will also be constructing a volcano throughout the week, which we will ‘erupt’ on the final class. Each class will focus on different activities; some experiments you will take home, as well as instructions on how to recreate it with your grown-ups outside of school.\nNote: Students will be grouped into cohorts based on age. *This program is also being offered the week of June 28",
    "Prerequisites": "None",
    "Location": "Oakwood Elementary School",
    "Length_In_Weeks": 1,
    "Start_Date": "August 9",
    "End_Date": "August 13",
    "Start_Time": "9:00 AM",
    "End_Time": "12:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "24 max",
    "Tuition": "$350.00",
    "Material_Fee": "$10.00",
    "Hrs_per_day": "3:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/214124",
    "Grade_00": "FALSE",
    "Grade_01": "TRUE",
    "Grade_02": "TRUE",
    "Grade_03": "TRUE",
    "Grade_04": "TRUE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Samantha Brawn",
    "Instructor_email": "sbrawn@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Arts",
    "Program_Code": "EXP2021-L1",
    "Program_Name": "Exploratorium Level 1",
    "Program_Chair": "Lisa Pimentel",
    "Program_Chair_Email": "lpimentel@oakwoodschool.org",
    "Grades": "4-6",
    "Program_Description": "Oakwood’s flagship summer Arts program, the Exploratorium is returning to the Elementary campus this summer!  This two-week, immersive experience allows students to select a “major” as their main focus area while still exploring other artistic disciplines each day.  Whether you’re an advanced actor, beginning bassoonist, fledgling filmmaker, proficient photographer or anywhere else on the spectrum of arts interests and abilities, the Exploratorium has a place for you! Final performances for the Exploratorium will take place over the weekend of July 17th-18th.",
    "Prerequisites": "Instrumental music students must have one year of experience studying their instrument. There is no prerequisite for acting, singing, dancing, production classes, or art classes.",
    "Location": "Oakwood Elementary School",
    "Length_In_Weeks": 2,
    "Start_Date": "July 6",
    "End_Date": "July 18",
    "Start_Time": "9:00 AM",
    "End_Time": "1:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "24 max",
    "Tuition": "$1,200.00",
    "Material_Fee": "",
    "Hrs_per_day": "4:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/208168",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "TRUE",
    "Grade_05": "TRUE",
    "Grade_06": "TRUE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Lisa Pimentel",
    "Instructor_email": "lpimentel@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Arts",
    "Program_Code": "EXP2021-L2",
    "Program_Name": "Exploratorium Level 2",
    "Program_Chair": "Lisa Pimentel",
    "Program_Chair_Email": "lpimentel@oakwoodschool.org",
    "Grades": "7-8",
    "Program_Description": "Oakwood’s flagship summer Arts program, the Exploratorium is returning to the Secondary campus!  This two-week, immersive experience allows students to select a “major” as their main focus area while still exploring other artistic disciplines each day.  Whether you’re an advanced actor, beginning bassoonist, fledgling filmmaker, proficient photographer or anywhere else on the spectrum of arts interests and abilities, the Exploratorium has a place for you! Final performances for the Exploratorium will take place over the weekend of July 17th-18th.",
    "Prerequisites": "None",
    "Location": "Oakwood Secondary School",
    "Length_In_Weeks": 2,
    "Start_Date": "July 6",
    "End_Date": "July 18",
    "Start_Time": "9:00 AM",
    "End_Time": "1:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "24 max",
    "Tuition": "$1,200.00",
    "Material_Fee": "",
    "Hrs_per_day": "4:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/208173",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Lisa Pimentel",
    "Instructor_email": "lpimentel@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Arts",
    "Program_Code": "EXP2021-L3",
    "Program_Name": "Exploratorium Level 3",
    "Program_Chair": "Lisa Pimentel",
    "Program_Chair_Email": "lpimentel@oakwoodschool.org",
    "Grades": "9-12",
    "Program_Description": "Oakwood’s flagship summer Arts program, the Exploratorium is returning to the Secondary campus!  This two-week, immersive experience allows students to select a “major” as their main focus area while still exploring other artistic disciplines each day.  Whether you’re an advanced actor, beginning bassoonist, fledgling filmmaker, proficient photographer or anywhere else on the spectrum of arts interests and abilities, the Exploratorium has a place for you! Final performances for the Exploratorium will take place over the weekend of July 17th-18th.",
    "Prerequisites": "None",
    "Location": "Oakwood Secondary School",
    "Length_In_Weeks": 2,
    "Start_Date": "July 6",
    "End_Date": "July 18",
    "Start_Time": "9:00 AM",
    "End_Time": "1:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "24 max",
    "Tuition": "$1,200.00",
    "Material_Fee": "",
    "Hrs_per_day": "4:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/208174",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "TRUE",
    "Grade_10": "TRUE",
    "Grade_11": "TRUE",
    "Grade_12": "TRUE",
    "Grade_12+": "TRUE",
    "instructor": "Lisa Pimentel",
    "Instructor_email": "lpimentel@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Mathematics & Coding/STEAM",
    "Program_Code": "CDG2021-L1",
    "Program_Name": "Coding/STEAM Camp Level 1",
    "Program_Chair": "Shane Finch",
    "Program_Chair_Email": "sfinch@oakwoodschool.org",
    "Grades": "1-2",
    "Program_Description": "Rising 1st and 2nd Graders will have a ton of fun in this coding and STEAM camp! Whether programming their own games, assembling a functional instrument with playdoh, or helping a robot find its way around, students are sure to have a blast while gaining fundamental problem-solving skills. No experience required!",
    "Prerequisites": "None",
    "Location": "Oakwood Elementary School",
    "Length_In_Weeks": 1,
    "Start_Date": "August 2",
    "End_Date": "August 6",
    "Start_Time": "9:00 AM",
    "End_Time": "1:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$467.00",
    "Material_Fee": "$10.00",
    "Hrs_per_day": "4:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/212434",
    "Grade_00": "FALSE",
    "Grade_01": "TRUE",
    "Grade_02": "TRUE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Shane Finch",
    "Instructor_email": "sfinch@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Mathematics & Coding/STEAM",
    "Program_Code": "CDG2021-L2",
    "Program_Name": "Coding/STEAM Camp Level 2",
    "Program_Chair": "Shane Finch",
    "Program_Chair_Email": "sfinch@oakwoodschool.org",
    "Grades": "3-4",
    "Program_Description": "Does your rising 3rd or 4th Grader love coding and STEAM? Well look no further! Students will engage in project-based fun that includes a variety of programming, technical design, and robotics while gaining fundamental problem-solving skills. No experience required!",
    "Prerequisites": "None",
    "Location": "Oakwood Elementary School",
    "Length_In_Weeks": 1,
    "Start_Date": "July 26",
    "End_Date": "July 30",
    "Start_Time": "9:00 AM",
    "End_Time": "1:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$467.00",
    "Material_Fee": "$10.00",
    "Hrs_per_day": "4:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/208187",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "TRUE",
    "Grade_04": "TRUE",
    "Grade_05": "FALSE",
    "Grade_06": "FALSE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Shane Finch",
    "Instructor_email": "sfinch@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Mathematics & Coding/STEAM",
    "Program_Code": "CDG2021-L3",
    "Program_Name": "Coding/STEAM Camp Level 3",
    "Program_Chair": "Shane Finch",
    "Program_Chair_Email": "sfinch@oakwoodschool.org",
    "Grades": "5-6",
    "Program_Description": "Is your rising 5th or 6th grader passionate about coding, design, robotics, engineering, or all-things-technical!? Don't let this opportunity pass them by! This project-based, week-long program is the ideal setting to inspire young innovators, spark their creativity and curiosity, and gain fundamental problem-solving skills. No experience required!",
    "Prerequisites": "None",
    "Location": "Oakwood Elementary School",
    "Length_In_Weeks": 1,
    "Start_Date": "June 21",
    "End_Date": "June 25",
    "Start_Time": "9:00 AM",
    "End_Time": "1:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "12 max",
    "Tuition": "$467.00",
    "Material_Fee": "$10.00",
    "Hrs_per_day": "4:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/212433",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "FALSE",
    "Grade_04": "FALSE",
    "Grade_05": "TRUE",
    "Grade_06": "TRUE",
    "Grade_07": "FALSE",
    "Grade_08": "FALSE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Shane Finch",
    "Instructor_email": "sfinch@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Athletics/Sports",
    "Program_Code": "SPO2021-BS",
    "Program_Name": "Baseball Skill Development Camp",
    "Program_Chair": "Steve Smith",
    "Program_Chair_Email": "ssmith@oakwoodschool.org",
    "Grades": "3-8",
    "Program_Description": "This camp is for the serious athlete who is seeking a more rigorous training experience. Players will work with Oakwood's teams of experienced coaches to help further their athletic development and to refine their baseball skills.",
    "Prerequisites": "None",
    "Location": "Oakwood Secondary School",
    "Length_In_Weeks": 1,
    "Start_Date": "July 26",
    "End_Date": "July 30",
    "Start_Time": "9:00 AM",
    "End_Time": "1:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "24 max",
    "Tuition": "$467.00",
    "Material_Fee": "",
    "Hrs_per_day": "4:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/213751",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "TRUE",
    "Grade_04": "TRUE",
    "Grade_05": "TRUE",
    "Grade_06": "TRUE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Avery Ware",
    "Instructor_email": "aware@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Athletics/Sports",
    "Program_Code": "SPO2021-BB",
    "Program_Name": "Basketball Skill Development Camp (Co-ed)",
    "Program_Chair": "Steve Smith",
    "Program_Chair_Email": "ssmith@oakwoodschool.org",
    "Grades": "3-8",
    "Program_Description": "This camp is for the serious athlete who is seeking a more rigorous training experience. Players will work with Oakwood's teams of experienced coaches to help further their athletic development and to refine their basketball skills.",
    "Prerequisites": "None",
    "Location": "Oakwood Secondary School",
    "Length_In_Weeks": 1,
    "Start_Date": "July 19",
    "End_Date": "July 23",
    "Start_Time": "9:00 AM",
    "End_Time": "1:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "24 max",
    "Tuition": "$467.00",
    "Material_Fee": "",
    "Hrs_per_day": "4:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/213753",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "TRUE",
    "Grade_04": "TRUE",
    "Grade_05": "TRUE",
    "Grade_06": "TRUE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Steve Smith and Brandon Smith",
    "Instructor_email": "ssmith@oakwoodschool.org bsmith@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Athletics/Sports",
    "Program_Code": "SPO2021-TN",
    "Program_Name": "Tennis Skill Development Camp (Co-ed)",
    "Program_Chair": "Steve Smith",
    "Program_Chair_Email": "ssmith@oakwoodschool.org",
    "Grades": "3-8",
    "Program_Description": "This camp is for the serious tennis athlete who is seeking a more rigorous training experience. Players will work with Oakwood's teams of experienced coaches to help further their athletic development and to refine their skills. *Please note that this course may have an added facilities fee.",
    "Prerequisites": "None",
    "Location": "Van Nuys/Sherman Oaks Pay Tennis, Department of Recreation and Parks and Rec.",
    "Length_In_Weeks": 1,
    "Start_Date": "June 21",
    "End_Date": "June 25",
    "Start_Time": "9:00 AM",
    "End_Time": "1:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "24 max",
    "Tuition": "$467.00",
    "Material_Fee": "$80.00",
    "Hrs_per_day": "4:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/213844",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "TRUE",
    "Grade_04": "TRUE",
    "Grade_05": "TRUE",
    "Grade_06": "TRUE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Nikki Robbins",
    "Instructor_email": "nrobbins@oakwoodschool.org",
    "New_since_Mar10": "NEW!",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  },
  {
    "Program_Category": "Athletics/Sports",
    "Program_Code": "SPO2021-VB",
    "Program_Name": "Volleyball Skill Development Camp (Co-ed)",
    "Program_Chair": "Steve Smith",
    "Program_Chair_Email": "ssmith@oakwoodschool.org",
    "Grades": "3-8",
    "Program_Description": "This camp is for the serious volleyball athlete who is seeking a more rigorous training experience. Players will work with Oakwood's teams of experienced coaches to help further their athletic development and to refine their skills.",
    "Prerequisites": "None",
    "Location": "Oakwood Secondary School",
    "Length_In_Weeks": 1,
    "Start_Date": "June 21",
    "End_Date": "June 25",
    "Start_Time": "9:00 AM",
    "End_Time": "1:00 PM",
    "Days_of_the_week": "Monday-Friday",
    "Min_Students": "6 min",
    "Max_Students": "24 max",
    "Tuition": "$467.00",
    "Material_Fee": "",
    "Hrs_per_day": "4:00:00",
    "In_Person": "TRUE",
    "Virtual": "FALSE",
    "Hybrid": "FALSE",
    "Registration_Link": "https://www.hisawyer.com/oakwood-summer-programs/schedules/activity-set/213835",
    "Grade_00": "FALSE",
    "Grade_01": "FALSE",
    "Grade_02": "FALSE",
    "Grade_03": "TRUE",
    "Grade_04": "TRUE",
    "Grade_05": "TRUE",
    "Grade_06": "TRUE",
    "Grade_07": "TRUE",
    "Grade_08": "TRUE",
    "Grade_09": "FALSE",
    "Grade_10": "FALSE",
    "Grade_11": "FALSE",
    "Grade_12": "FALSE",
    "Grade_12+": "FALSE",
    "instructor": "Ryan Duncan",
    "Instructor_email": "rduncan@oakwoodschool.org",
    "New_since_Mar10": "",
    "": "",
    "__1": "",
    "__2": "",
    "__3": "",
    "__4": "",
    "__5": "",
    "__6": "",
    "__7": ""
  }
]
    
